



















// export default class Home extends Vue {}
export default {
  data() {},
  mounted() {
  }
};
